// GrayScale gray_5 — placeholder 색상
export const PLACEHOLDER_COLOR = '#B7BBC2';

export const DateSelectorNormalizedStyle = {
  borderRadius: '8px',
  '& .MuiInputBase-root': {
    background: 'var(--dk-bg, #ffffff)',
    height: '44px',
    boxSizing: 'border-box',
    outline: 'none',
  },
  '.MuiOutlinedInput-notchedOutline': {
    top: 0,
    borderWidth: '1px',
    borderColor: 'var(--dk-line, #E7E9EC)',
    '> legend': {
      display: 'none',
    },
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    padding: 0,
    margin: 0,
    outline: 'none',
    '&:focus, &:focus-visible': {
      outline: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#000 !important',
      borderWidth: '1px !important',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--dk-line, #E7E9EC)',
    borderWidth: '1px',
  },
  '& .MuiInputAdornment-root': {
    width: '20px',
    height: '20px',
    margin: '0 16px 0 0',
    padding: 0,

    '.MuiButtonBase-root': {
      padding: 0,
      margin: 0,
      width: '100%',
      height: '100%',
      '&.Mui-focusVisible, &:focus-visible': {
        outline: '1px solid #000',
        borderRadius: '4px',
      },
    },
  },
  '& .MuiInputBase-input': {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    padding: '12px 0 12px 16px',
    outline: 'none',

    // 달력으로만 값 선택(readOnly)하는 필드이므로, 표시된 값 텍스트가
    // 드래그/클릭으로 선택·하이라이트되지 않도록
    userSelect: 'none',
    WebkitUserSelect: 'none',
    '&::selection': {
      backgroundColor: 'transparent',
    },

    '&::placeholder': {
      color: PLACEHOLDER_COLOR,
      opacity: 1,
    },
  },
};
